import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const ProductLogList = props => {
    if (!props.logs) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.logs.length === 0) {
        return (
            <div className='empty'>
                No logs...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>operator</th>
                        <th>previous state</th>
                        <th>current state</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.logs.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/users/${item.operator}`}>{item.operator}</Link></td>
                                    <td className="keyfield">
                                        <strong>Name:</strong> {item.previous_variable.name} <br />
                                        <strong>Price:</strong> {item.previous_variable.price} <br />
                                        <strong>Currency:</strong> {item.previous_variable.currency} <br />
                                        <strong>Category:</strong> <Link to={`/category/${item.previous_variable.category_key}/detail`}>{item.previous_variable.category_name}</Link><br />
                                    </td>
                                    <td className="keyfield">
                                        <strong>Name:</strong> {item.current_variable.name} <br />
                                        <strong>Price:</strong> {item.current_variable.price} <br />
                                        <strong>Currency:</strong> {item.current_variable.currency} <br />
                                        <strong>Category:</strong> <Link to={`/category/${item.current_variable.category_key}/detail`}>{item.current_variable.category_name}</Link><br />
                                    </td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ProductLogList;



// WEBPACK FOOTER //
// ./src/components/widgets/ProductLogList.js